module.exports = __webpack_public_path__ + "img/hotel_1.d52b00b4.png";